import { getJSON } from 'common/services/api'
import { REVISION_QUERY_KEY, REVISION_URL } from './queryConstants'
import { useQuery } from 'react-query'

type UseRevisionDetailReturn = {
  revisionDetail: any
  isLoadingRevisionDetail: boolean
}

type UseRevisionDetailProps = {
  id?: string
}

const useRevisionDetail = ({
  id,
}: UseRevisionDetailProps): UseRevisionDetailReturn => {
  // Detail
  const { data: revisionDetail, isLoading: isLoadingRevisionDetail } = useQuery(
    [REVISION_QUERY_KEY, id] as string[],
    () =>
      getJSON({
        url: `${REVISION_URL}/${id}`,
        isRota: true,
      }),
    { enabled: !!id }
  )

  return {
    revisionDetail,
    isLoadingRevisionDetail,
  }
}

export default useRevisionDetail
